import React from "react";
import Script from 'react-load-script'

export default function GoogleTrends({ elementId, type, comparison, keyword, geo, time, property }) {
    console.log(elementId);
    console.log(type);
    console.log(keyword)
    const handleScriptLoad = () => {
        console.log("GO")
        window.trends.embed.renderExploreWidgetTo(document.getElementById(elementId), type, {
            comparisonItem: [{
                "keyword": keyword,
                "geo": geo,
                "time": time,
            }],
            category: 0,
            property: ""
        }, {
            exploreQuery: `q=${keyword}&geo=${geo}#${type}&date=${time}`,
            guestPath: "https://trends.google.com:443/trends/embed/"
        })
    };

    return <Script url="https://ssl.gstatic.com/trends_nrtr/2379_RC01/embed_loader.js" onLoad={handleScriptLoad}></Script>
}